import {
  REMOVE_EXPENSE,
  REMOVE_ALLOWANCE,
  GET_EXPENSE_SUCCESS,
  SAVE_EXPENSE,
  SAVE_EXPENSE_SUCCESS,
  SAVE_EXPENSE_FAILED,
  CLOSE_EXPENSE_SNACKBAR,
  EXPENSE_CHANGE_PAGE,
  LOAD_ALLOWANCE_COST_SUCCESS,
  ALLOWANCE_CHANGE_PAGE,
  SAVE_ALLOWANCE,
  SAVE_ALLOWANCE_SUCCESS,
  SAVE_ALLOWANCE_FAILED,
  GET_EXPENSE_BY_ID_SUCCESS,
  GET_ALLOWANCE_BY_ID_SUCCESS,
  SAVE_EXPENSE_UPDATE,
  EXPENSE_UPDATE_SUCCESS,
  EXPENSE_UPDATE_FAILED,
  CANCEL_EXPENSE_UPDATE,
  CANCEL_ALLOWANCE_UPDATE,
  CHANGE_PURCHASE_DATE,
  SAVE_ALLOWANCE_UPDATE,
  ALLOWANCE_UPDATE_SUCCESS,
  ALLOWANCE_UPDATE_FAILED,
  ALLOWANCE_UPDATE_EXCEED_LIMIT_FAILED,
  EMPTY_PASSENGER_ROWS,
  // SELECT_EXPENSE_ID,
  // ADD_EXPENSES_TO_INVOICE,
  UPDATE_INVOICEID_TO_EXPENSE,
  SHOW_EXPENSE_DIALOG,
  CANCEL_EXPENSE_DIALOG,
  SHOW_ALLOWANCE_DIALOG,
  CANCEL_ALLOWANCE_DIALOG,
  LOCATION_CHANGE,
  EDIT_EXPENSE,
  EDIT_ALLOWANCE,
  CLOSE_EXP_INVOICE_WARN_SNACK_BAR,
  RESET_EXPENSE_ALLOWANCE_SELECTION,
  CLOSE_ALLOWANCE_INVOICE_WARN_SNACK_BAR,
  UPDATE_INVOICEID_TO_ALLOWANCE,
  UPDATE_INVOICEID_TO_INFO_SUCCESS,
  UPDATE_INVOICEID_TO_INFO_EXCEED_LIMIT_FAILED,
  UPDATE_INVOICEID_TO_INFO_FAILED,
  CANCEL_INVOICE_INFO_DIALOG,
  UPDATE_EXPENSE_SELECTED_LIST,
  PRICE_CHANGE,
  DISABLE_ALLOWANCE_BACK_BTN,
  DISABLE_EXPENSE_BACK_BTN,
  COPY_ALLOWANCE
} from '../constants/index'

const initialState = {
  expenses: [],
  currentPrice: 1,
  expenseRow: [],
  expenseRowCounter: 1,
  allowanceRowCounter: 2,
  passengerRowCounter: 0,
  allowances: [],
  allowanceRow: [],
  showAdditionalInfo: false,
  days: 0,
  hours: 0,
  passengerPrice: 0.03,
  showSpinner: false,
  showSnackbar: false,
  showFailSnackbar: false,
  errorStatus: 0,
  expenseEdit: [],
  allowanceEdit: [],
  isEdit: false,
  isChangeComponent: false,
  expenseSelected: [],
  allowanceSelected: [],
  allowanceCheckSelected: [],
  selectedExpenseIds: [],
  selectedAllowanceIds: [],
  indexExist: true,
  indexAllowExist: true,
  showWarnExpInvoiceSnackbar: false,
  showWarnAllowInvoiceSnackbar: false,
  showExpDialog: false,
  showTravelDialog: false,
  showInvoiceInfoSuccess: false,
  showInvoiceInfoFailed: false,
  errMessage: '',
  isSaveAllowance: false
}

const expenseReducer = (state = initialState, action) => {
  switch (action.type) {
    case PRICE_CHANGE:
      return { ...state, currentPrice: action.price }

    case UPDATE_INVOICEID_TO_EXPENSE:
      return Object.assign({}, state, {
        showExpDialog: false
      })

    case SHOW_EXPENSE_DIALOG:
      return Object.assign({}, state, {
        showExpDialog: action.selected.length > 0 ? true : false,
        showWarnExpInvoiceSnackbar: action.selected.length > 0 ? false : true
      })

    case CANCEL_EXPENSE_DIALOG:
      return Object.assign({}, state, {
        showExpDialog: false
      })

    case UPDATE_INVOICEID_TO_INFO_SUCCESS:
      return Object.assign({}, state, {
        showInvoiceInfoSuccess: true
      })

    case UPDATE_INVOICEID_TO_INFO_EXCEED_LIMIT_FAILED:
      return Object.assign({}, state, {
        showInvoiceInfoFailed: true
      })

    case UPDATE_INVOICEID_TO_INFO_FAILED:
      return Object.assign({}, state, {
        showInvoiceInfoFailed: true
      })

    case CANCEL_INVOICE_INFO_DIALOG:
      return Object.assign({}, state, {
        showInvoiceInfoSuccess: false,
        showInvoiceInfoFailed: false
      })

    case SHOW_ALLOWANCE_DIALOG:
      return Object.assign({}, state, {
        showTravelDialog: action.selected.length > 0 ? true : false,
        showWarnAllowInvoiceSnackbar: action.selected.length > 0 ? false : true
      })

    case CANCEL_ALLOWANCE_DIALOG:
      return Object.assign({}, state, {
        showTravelDialog: false
      })

    case UPDATE_INVOICEID_TO_ALLOWANCE:
      return Object.assign({}, state, {
        showTravelDialog: false
      })

    case CLOSE_EXP_INVOICE_WARN_SNACK_BAR:
      return Object.assign({}, state, {
        showWarnExpInvoiceSnackbar: false
      })

    case RESET_EXPENSE_ALLOWANCE_SELECTION:
      return Object.assign(
        {},
        {
          ...state
        },
        {
          showWarnAllowInvoiceSnackbar: false,
          showWarnExpInvoiceSnackbar: false
        }
      )

    case LOCATION_CHANGE:
      if (action.payload.pathname != null) {
        if (
          action.payload.pathname != '/dashboard/invoice' &&
          action.payload.pathname === '/dashboard/fee' &&
          action.payload.pathname != '/dashboard/fee/newfee' &&
          action.payload.pathname != '/dashboard/fee/newallowance' &&
          action.payload.pathname != '/dashboard/invoice/review'
        ) {
          return Object.assign(
            {},
            {
              ...state
            },
            {
              expenseSelected: 0,
              allowanceSelected: 0,
              allowanceCheckSelected: [],
              selectedExpenseIds: [],
              selectedAllowanceIds: [],
              showWarnAllowInvoiceSnackbar: false,
              showWarnExpInvoiceSnackbar: false
            }
          )
        } else {
          return Object.assign(
            {},
            {
              ...state
            },
            {
              expenseSelected: 0,
              allowanceSelected: 0,
              showWarnAllowInvoiceSnackbar: false,
              showWarnExpInvoiceSnackbar: false
            }
          )
        }
      } else {
        return Object.assign(
          {},
          { ...state },
          {
            showSnackbar: false,
            showFailSnackbar: false,
            errorStatus: 0,
            isEdit: false,
            errMessage: '',
            isSaveAllowance: false,
            expenseSelected: 0,
            allowanceSelected: 0
          }
        )
      }

    case DISABLE_ALLOWANCE_BACK_BTN:
      return Object.assign({}, state, {
        showSpinner: false
      })

    case DISABLE_EXPENSE_BACK_BTN:
      return Object.assign({}, state, {
        showSpinner: false
      })

    case CLOSE_ALLOWANCE_INVOICE_WARN_SNACK_BAR:
      return Object.assign({}, state, {
        showWarnAllowInvoiceSnackbar: false
      })

    case UPDATE_EXPENSE_SELECTED_LIST:
      return {
        ...state,
        expenseSelected: action.list
      }

    case GET_EXPENSE_SUCCESS:
      return Object.assign(
        {},
        {
          ...state
        },
        {
          showWarnAllowInvoiceSnackbar: false,
          showWarnExpInvoiceSnackbar: false,
          expenses: action.expenses,
          allowances: action.allowances,
          showSpinner: false
        }
      )

    case SAVE_EXPENSE:
      return Object.assign({}, state, {
        showSpinner: true
      })

    case SAVE_EXPENSE_UPDATE:
      return Object.assign({}, state, {
        showSpinner: true
      })

    case SAVE_EXPENSE_SUCCESS:
      return Object.assign({}, state, {
        isSaveAllowance: false,
        showSpinner: false,
        showSnackbar: true
      })

    case SAVE_EXPENSE_FAILED:
      return Object.assign({}, state, {
        isSaveAllowance: false,
        showSpinner: false,
        showFailSnackbar: true,
        errorStatus: action.errorStatus
      })

    case CLOSE_EXPENSE_SNACKBAR:
      return Object.assign({}, state, {
        showSnackbar: false,
        showFailSnackbar: false,
        errorStatus: 0,
        showSpinner: false,
        errMessage: ''
      })

    case EMPTY_PASSENGER_ROWS:
      return Object.assign({}, state, {
        allowancePassenger: [],
        passengerRowCounter: 0,
        passengerPrice: 0
      })

    case REMOVE_EXPENSE:
      return Object.assign(
        {},
        {
          ...state
        },
        {
          expenses: state.expenses.filter(
            (el) => el.invoice_expense_id !== action.invoice_expense_id
          )
        }
      )

    case REMOVE_ALLOWANCE:
      let indexAllowExist
      if (state.allowanceCheckSelected.includes(action.index)) {
        indexAllowExist = true
      } else indexAllowExist = false

      let newAllowSelectedArray = state.allowanceCheckSelected

      for (var i = 0; i < newAllowSelectedArray.length; i++) {
        if (newAllowSelectedArray[i] > action.index) {
          newAllowSelectedArray[i] = newAllowSelectedArray[i] - 1
        }
      }

      return Object.assign({}, state, {
        indexAllowExist: indexAllowExist,
        allowances: state.allowances.filter((el) => el.id !== action.id),
        allowanceCheckSelected: newAllowSelectedArray
      })

    case EXPENSE_CHANGE_PAGE:
      return Object.assign(
        {},
        {
          ...state
        },
        {
          expenseSelected: action.selected.selected
        }
      )

    case LOAD_ALLOWANCE_COST_SUCCESS:
      const allowanceCost = action.result.reduce((allCost, el) => {
        el.type === 'full_time_allowance'
          ? (allCost[el.type] = { full_time_allowance: el.fulltimeallowance })
          : (allCost[el.type] = { id: el.id, value: el.value, year: el.year })
        return allCost
      }, {})
      return Object.assign({}, state, {
        allowanceCost: {
          ...allowanceCost,
          select: {
            id: 'select',
            value: 0
          }
        }
      })

    case ALLOWANCE_CHANGE_PAGE:
      return Object.assign(
        {},
        {
          ...state
        },
        {
          allowanceSelected: action.selected.selected
        }
      )

    case SAVE_ALLOWANCE:
      return Object.assign({}, state, {
        showSpinner: true
      })

    case SAVE_ALLOWANCE_SUCCESS:
      return Object.assign({}, state, {
        showSpinner: false,
        showSnackbar: true,
        passengerPrice: 0,
        passengerRowCounter: 0,
        allowancePassenger: [],
        allowanceCheckSelected: [],
        isSaveAllowance: true
      })

    case SAVE_ALLOWANCE_FAILED:
      return Object.assign({}, state, {
        showSpinner: false,
        showFailSnackbar: true,
        passengerPrice: 0,
        passengerRowCounter: 0,
        allowancePassenger: [],
        errMessage: action.error,
        isSaveAllowance: true
      })

    case GET_EXPENSE_BY_ID_SUCCESS:
      return Object.assign(
        {},
        {
          ...state
        },
        {
          expenseEdit: action.result,
          isEdit: true
        }
      )

    case EDIT_EXPENSE:
      return Object.assign(
        {},
        {
          ...state
        },
        {
          indexExist: false
        }
      )

    case EDIT_ALLOWANCE:
      return Object.assign(
        {},
        {
          ...state
        },
        {
          indexAllowExist: false
        }
      )

    case GET_ALLOWANCE_BY_ID_SUCCESS:
      return Object.assign(
        {},
        {
          ...state
        },
        {
          allowanceEdit: action.result,
          isEdit: true
        }
      )

    case EXPENSE_UPDATE_SUCCESS:
      return Object.assign(
        {},
        {
          ...state
        },
        {
          showSpinner: false,
          showSnackbar: true,
          expenseEdit: [],
          isEdit: false,
          expenseRowCounter: 1
        }
      )

    case EXPENSE_UPDATE_FAILED:
      return Object.assign(
        {},
        {
          ...state
        },
        {
          expenseEdit: [],
          isEdit: false,
          expenseRowCounter: 1,
          showFailSnackbar: true,
          showSpinner: false
        }
      )

    case CANCEL_EXPENSE_UPDATE:
      return Object.assign(
        {},
        {
          ...state
        },
        {
          expenseEdit: [],
          isEdit: false,
          expenseRowCounter: 1
        }
      )

    case SAVE_ALLOWANCE_UPDATE:
      return Object.assign({}, state, {
        showSpinner: true
      })

    case ALLOWANCE_UPDATE_SUCCESS:
      return Object.assign(
        {},
        {
          ...state
        },
        {
          showSpinner: false,
          showSnackbar: true,
          allowanceEdit: [],
          isEdit: false,
          passengerRowCounter: 0,
          passengerPrice: 0,
          allowanceRowCounter: 2
        }
      )

    case ALLOWANCE_UPDATE_FAILED:
      return Object.assign(
        {},
        {
          ...state
        },
        {
          showSpinner: false,
          showSnackbar: false,
          allowanceEdit: [],
          isEdit: false,
          allowanceRowCounter: 2,
          passengerRowCounter: 0,
          passengerPrice: 0,
          errMessage: action.error
        }
      )

    case ALLOWANCE_UPDATE_EXCEED_LIMIT_FAILED:
      return Object.assign(
        {},
        {
          ...state
        },
        {
          showSpinner: false,
          showFailSnackbar: true,
          allowanceRowCounter: 2,
          passengerRowCounter: 0,
          passengerPrice: 0,
          isSaveAllowance: true
        }
      )

    case CANCEL_ALLOWANCE_UPDATE:
      return Object.assign(
        {},
        {
          ...state
        },
        {
          allowanceEdit: [],
          isEdit: false,
          passengerRowCounter: 0,
          passengerPrice: 0,
          allowanceRowCounter: 2
        }
      )

    case CHANGE_PURCHASE_DATE:
      return Object.assign({}, state, {
        date_of_purchase: action.date
      })

    case COPY_ALLOWANCE:
      return Object.assign({}, { ...state }, { indexAllowExist: false })

    default:
      return state
  }
}

export default expenseReducer
